import React, { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { COMMON_FLAGS, useCommonConfig } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { Parameter } from '../Parameter/Parameter';
import styles from './parameterList.module.scss';

export const ParameterList = ({ parameters, isUrlEvent, id, defaultMessage }) => {
    const { [COMMON_FLAGS.PIXEL_TESTER_EVENTS_BLACK_LIST_PARAMETERS]: blackListParameters } = useCommonConfig([
        COMMON_FLAGS.PIXEL_TESTER_EVENTS_BLACK_LIST_PARAMETERS,
    ]);

    const filteredParameters = parameters?.filter(param => !blackListParameters.includes(param.name));

    const sortedParameters = useMemo(() => {
        if (isEmpty(filteredParameters)) return [];
        return [...filteredParameters].sort((a, b) => a.name.localeCompare(b.name));
    }, [filteredParameters]);

    if (isEmpty(filteredParameters)) return null;

    return (
        <div className={styles['container']}>
            <FormattedMessage
                id={`pixel.tester.event.data.parameter.${id}.title`}
                defaultMessage={defaultMessage}
                className={styles['key']}
            />
            <div className={styles['parameters-container']}>
                {sortedParameters.map(({ name, value, validationError }, index) => (
                    <Parameter
                        key={`${name}-${value}-${index}`}
                        name={name}
                        value={value}
                        validationError={validationError}
                        isUrlEvent={isUrlEvent}
                    />
                ))}
            </div>
        </div>
    );
};
